import { Attributes, Misc, Rules, Validation, ValueObject } from '@singularsystems/neo-core';

export default class InterCompanyDividendLetterReportCriteria extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    public entityId: number | null = null;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public dividendDate: Date | null = null;

    @Rules.Required()
    @Attributes.Nullable()
    public investorId: number | null = null;

    // Client only properties / methods

    public investorName: string | null = null;

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Inter-Company Dividend Letter Criteria";
    }
}